//constants
import {
	DELETE_UPPER,
	DETAILS,
	CATEGORIES,
	ALL_CATEGORIES,
	AUCTION,
	ACTIVITY,
	ACTIVE,
	CLOSE_UPPER,
	EDIT_UPPER,
} from '@/utils/constants';
//enums
import {AUCTION_ACTIVITY, AUCTION_STATUS, AUCTION_TYPE} from '@/utils/enums';
//helpers
import {camelize} from '@/utils/helpers';
//types
import {IFilterGroup, IOrganizationAuctionCategory, IOrganizationAuctionResponse} from '@/utils/types';

export const tableActionMenuContent = [DETAILS, CLOSE_UPPER, ACTIVE, EDIT_UPPER, DELETE_UPPER];

export const auctionDefaultFilterValues = {
	sortColumn: '',
	isOrderDesc: false,
	activity: camelize(AUCTION_ACTIVITY.ALL_ITEMS),
	auctionType: camelize(AUCTION_TYPE.ALL_ITEMS),
	categoryIds: null,
};

export const auctionDefaultFilterData: IFilterGroup[] = [
	{
		title: ACTIVITY,
		options: [
			{title: AUCTION_ACTIVITY.ALL_ITEMS, isSelected: true},
			{title: AUCTION_ACTIVITY.ACTIVE, isSelected: false},
			{title: AUCTION_ACTIVITY.CLOSED, isSelected: false},
		],
	},
	{
		title: AUCTION,
		options: [
			{title: AUCTION_TYPE.ALL_ITEMS, isSelected: true},
			{title: AUCTION_TYPE.SILENT, isSelected: false},
			{title: AUCTION_TYPE.LIVE, isSelected: false},
		],
	},
	{
		title: CATEGORIES,
		options: [{title: ALL_CATEGORIES, isSelected: true, id: null}],
	},
];

export const updatedAuctionFilterOptions = (
	auctionCategories: IOrganizationAuctionCategory[],
	filterData: IFilterGroup[]
) =>
	filterData.map((filterGroup) =>
		filterGroup.title === CATEGORIES
			? {
					...filterGroup,
					options: [
						{
							title: ALL_CATEGORIES,
							isSelected: !filterGroup.options.every((option) => !option.isSelected && option.id === null),
							id: null,
							isCheckBox: false,
						},
						...auctionCategories.map((tier) => ({title: tier.name, isSelected: false, id: tier.id, isCheckBox: true})),
					],
			  }
			: filterGroup
	);

export const handleSetCategoryIds = (currentTierIds: number[] | null, id?: number) => {
	if (!id) return null;

	const isIdInTierIds = currentTierIds ? currentTierIds.includes(id) : false;

	if (isIdInTierIds) {
		const newTierIds = currentTierIds?.filter((tierId) => tierId !== id) || [];
		return newTierIds.length > 0 ? newTierIds : null;
	}
	return [...(currentTierIds || []), id];
};

export const getUpdatedFilterData = (
	currentFilterData: IFilterGroup[],
	groupTitle: string,
	optionTitle: string,
	selectedCheckboxId?: number | null
) => {
	const indexToUpdate = currentFilterData.findIndex((filterGroup) => filterGroup.title === groupTitle);

	return currentFilterData.map((filterGroup, index) => {
		if (index !== indexToUpdate) return filterGroup;

		switch (groupTitle) {
			case ACTIVITY:
			case AUCTION:
				return {
					...filterGroup,
					options: filterGroup.options.map((option) => ({
						...option,
						isSelected: option.title === optionTitle,
					})),
				};

			case CATEGORIES:
				const newOptions = filterGroup.options.map((option) => {
					if (option.isCheckBox && option.id === selectedCheckboxId) {
						return {
							...option,
							isSelected: !option.isSelected,
						};
					}
					return {
						...option,
					};
				});

				const hasSelectedCheckBox = newOptions.some((option) => option.isCheckBox && option.isSelected);

				const updatedOptions = newOptions.map((option) => {
					if ((!option.isCheckBox && hasSelectedCheckBox) || (option.isCheckBox && !hasSelectedCheckBox)) {
						return {
							...option,
							isSelected: false,
						};
					}

					if (!option.isCheckBox && !hasSelectedCheckBox) {
						return {
							...option,
							isSelected: true,
						};
					}

					return option;
				});

				return {
					...filterGroup,
					options: updatedOptions,
				};

			default:
				return filterGroup;
		}
	});
};

export const getUpdatedAuctionValues = (
	currentAuction: IOrganizationAuctionResponse,
	rowName: string,
	newValue: string,
	eventId: number
) => {
	const {id, name, value, minBid, bidIncrement, buyNowPrice, categoryId, description, isLiveAuction, status} =
		currentAuction;

	const reqBody = {
		images: currentAuction.itemImages.map(({image}, index) => {
			return {image: image.split('/')[4].split('?')[0], isMain: index === 0};
		}),
		name,
		value,
		minBid,
		bidIncrement,
		buyNowPrice,
		categoryId,
		description,
		eventId,
		donors: currentAuction.donors,
		isLiveAuction,
		status: status === AUCTION_STATUS.ACTIVE ? AUCTION_ACTIVITY.ACTIVE : AUCTION_ACTIVITY.CLOSED,
		id,
	};

	return {...reqBody, [rowName]: +newValue};
};

export const getUpdatedAuctionStatusValues = (currentAuction: IOrganizationAuctionResponse) => {
	const {status} = currentAuction;
	return {
		name: currentAuction.name,
		value: currentAuction.value,
		minBid: currentAuction.minBid,
		bidIncrement: currentAuction.bidIncrement,
		buyNowPrice: currentAuction.buyNowPrice,
		categoryId: currentAuction.categoryId,
		description: currentAuction.description,
		donors: currentAuction.donors,
		isLiveAuction: currentAuction.isLiveAuction,
		images: currentAuction.itemImages.map(({image}, index) => {
			return {image: image.split('/')[4].split('?')[0], isMain: index === 0};
		}),
		status: status === AUCTION_STATUS.ACTIVE ? AUCTION_ACTIVITY.CLOSED : AUCTION_ACTIVITY.ACTIVE,
	};
};
